module.exports = {
    "Empty": `Prazno`
};


//# sourceMappingURL=sr-SP.main.js.map
